import { Patient } from "@/src/data/allTypes";
import { HospitalisationTreatment } from "../hospitalisation/hospitalisationTreatment";

import { Hospitalisation } from "@/src/data/allTypes";
import { ConsignesCompartment } from "../hospitalisation/consignesCompartment";
import { MesuresCompartment } from "../hospitalisation/mesuresCompartment";
import { NurseExamDemandsCompartment } from "./nurseExamDemandsCompartment";
import { SamplesCompartment } from "../hospitalisation/samplesCompartment";
import { AnesthesiologyTreatment } from "../hospitalisation/anesthesiologyTreatment";
function NurseHospitalisationPage({
  patient,
  item,
}: {
  patient: Patient;
  item: Hospitalisation;
}) {
  return (
    <div className="c1 gap20">
      <HospitalisationTreatment
        color="green"
        patient={patient}
        parent={item}
      ></HospitalisationTreatment>

      <AnesthesiologyTreatment
        patient={patient}
        item={item}
      ></AnesthesiologyTreatment>

      <div className="c4 mc1 gap20">
        <NurseExamDemandsCompartment
          color="green"
          patient={patient}
          parent={item}
        />
        <SamplesCompartment
          patient={patient}
          parent={item}
          type="green"
        ></SamplesCompartment>
        <MesuresCompartment color="green" patient={patient} parent={item} />

        <ConsignesCompartment
          color="green"
          patient={patient}
          parent={item}
        ></ConsignesCompartment>
      </div>
    </div>
  );
}

export { NurseHospitalisationPage };
